import { DataBean } from "../../DataBean";


export class BudgetProduct extends DataBean {

    public async getBudgetProductCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBudgetProductCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }
}